<template>
  <div class="modal-window uts019">
    <header class="modal-header">
      <div class="tit">{{ $i18nUtil.trans("title.TodoLinkedModal.001","관련 보드 연결") }}</div>
      <button @click="$emit('close')" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <div class="info-txt">{{$i18nUtil.trans("message.TodoLinkedModal2.001","업무 보드를 연결하여 할 일을 수행해보세요.")}}</div>
      <div class="tab_ty3" id="tabsTy5">
        <ul class="tab-menu">
          <li
            v-for="(tab, index) in tabsTy5"
            v-bind:class="{ active: currentTab5 === index }"
            :key="index"
          >
            <input type="radio" name="tab1" :id="'tab1' + index" /><label
              :for="'tab1' + index"
              v-on:click="currentTab5Click(index)"
              >{{ tab }}</label
            >
          </li>
        </ul>
        <div class="tab-content">
          <!-- 과제 -->
          <div v-show="currentTab5 == 0">
            <div class="height">
              <div class="dropdown ty2 relative wide">
                  <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" class="disabled">
                            {{
                              selectedProjectInfo.projectId == undefined
                                ? $i18nUtil.trans("entity.project.search.select","과제 선택")
                                : searchProjectName
                            }}
                            <!-- addLinkProjectName -->
                          </v-btn>
                      </template>
                      <div class="dropdown-list">
                          <div class="scroll">
                              <div class="dropdown-list-item"
                                v-if="projectList.length == 0"
                              >
                                <div class="no-data">{{$i18nUtil.trans("search.034","등록된 과제가 없습니다.")}}</div>
                              </div>
                              <div
                                v-else 
                                class="dropdown-list-item"
                                v-for="(projectItem, projectIndex) in projectList"
                                :value="projectItem"
                                :key="projectItem.projectId + `test` + projectIndex"
                                @click="changeProject(projectItem, $event)"
                              >
                                <div class="tit">
                                  <button
                                    type="button"
                                    :class="{
                                      active:
                                        selectedProjectInfo.projectId == projectItem.projectId,
                                    }"
                                  >
                                    {{ projectItem.projectName }}
                                  </button>
                                </div>
                              </div>
                          </div>
                      </div>
                  </v-menu>
              </div>
              <div class="error" v-if="error_0_1">
                {{$i18nUtil.trans("UB001")}}
              </div>
            </div>
            <!-- <form action="" onsubmit="return false;" novalidate>
              <div class="search_ty1">
                <input
                  type="text"
                  required
                  placeholder="멤버로 활동중인 명을 입력하세요."
                  :value="searchProjectName"
                  @input="filterProject"
                  @keyup.enter="checkProjectName"
                />
                <button type="reset" class="btn_search" @click="filterProject">검색</button>
                <div
                  class="list scroll"
                  style="height: 100px"
                  v-if="isProjectShow"
                >
                  <ul>
                    <li
                      class="no-data"
                      style="padding-top: 20px"
                      v-if="projectListFilter.length == 0"
                    >{{$i18nUtil.trans("message.TodoLinkedModal2.003","등록된 과정이 없습니다.")}}</li>
                    <li
                      v-else
                      v-for="(projectItem, projectIndex) in projectListFilter"
                      :value="projectItem"
                      :key="projectItem.projectId + `test` + projectIndex"
                      @click="changeProject(projectItem, $event)"
                    >
                      <button type="button">
                        {{ projectItem.projectName }}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="error" v-if="error_0_1">{{$i18nUtil.trans("UB001")}}</div>
            </form> -->

            <div class="height">
              <div
                class="dropdown ty2 relative wide"
                :class="{
                  disabled: selectedProjectInfo.projectId == undefined,
                }"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on">
                      {{
                        addLinkProjectCategoryMid == ""
                          ? $i18nUtil.trans("entity.category.depth2.search.select","과정 선택")
                          : addLinkProjectCategoryName
                      }}</v-btn
                    >
                  </template>
                  <div class="dropdown-list">
                    <div class="scroll">
                      <div
                        class="dropdown-list-item"
                        style="padding-top: 30px"
                        v-if="projectFolderList.length == 0"
                      >
                        <div class="no-data">{{$i18nUtil.trans("search.014","등록된 과정이 없습니다.")}}</div>
                      </div>
                      <div
                        v-else
                        class="dropdown-list-item"
                        v-for="(item, projectFolderIndex) in projectFolderList"
                        :key="'projectFolder' + projectFolderIndex"
                        @click="changeProjectFolder(item, 'dtProjectFolder')"
                      >
                        <div class="tit">
                          <button
                            type="button"
                            :class="{
                              active:
                                addLinkProjectCategoryMid == item.categoryMid,
                            }"
                          >
                            {{ item.categoryName }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-menu>
              </div>
              <div class="error" v-if="error_0_3">
                {{$i18nUtil.trans("UB012")}}
              </div>
            </div>

            <div class="height">
              <div
                class="dropdown ty2 relative wide"
                :class="{ disabled: addLinkProjectId == '' }"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on">{{
                      groupBoard.paperId == undefined
                        ? $i18nUtil.trans("message.TodoLinkedModal.004","업무 보드 선택")
                        : groupBoard.paperTitle
                    }}</v-btn>
                  </template>
                  <div class="dropdown-list">
                    <div class="scroll">
                      <div
                        class="dropdown-list-item"
                        style="padding-top: 30px"
                        v-if="groupBoardList.length == 0"
                      >
                        <div class="no-data">{{ $i18nUtil.trans("search.035","등록된 보드가 없습니다.") }}</div>
                      </div>
                      <div
                        class="dropdown-list-item"
                        v-for="(item, groupBoardIndex) in groupBoardList"
                        :key="'groupBoardIndex_' + groupBoardIndex"
                        @click="setGroupBoard(item)"
                      >
                        <div class="tit">
                          <button
                            type="button"
                            :class="{
                              active: item.paperId == groupBoard.paperId,
                            }"
                          >
                            {{ item.paperTitle }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-menu>
              </div>
              <div class="error" v-if="error_0_2">
                {{$i18nUtil.trans("UB025")}}
              </div>
            </div>
          </div>
          <!-- 공유받은 비공개 보드 -->
          <div v-show="currentTab5 == 1">
            <div class="height">
              <div class="dropdown ty2 relative wide">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="disabled"
                      :class="{
                        disabled: memberBoard.paperId == undefined,
                      }"
                      >{{
                        memberBoard.paperId == undefined
                          ? $i18nUtil.trans("message.TodoLinkedModal.004","업무 보드 선택")
                          : memberBoard.paperTitle
                      }}</v-btn
                    >
                  </template>
                  <div class="dropdown-list">
                    <div class="scroll">
                      <div
                        class="dropdown-list-item"
                        style="padding-top: 30px"
                        v-if="memberBoardList.length == 0"
                      >
                        <div class="no-data">{{ $i18nUtil.trans("search.035","등록된 보드가 없습니다.") }}</div>
                      </div>
                      <div
                        v-else
                        class="dropdown-list-item"
                        v-for="(item, index) in memberBoardList"
                        :key="'memberBoardList' + index"
                      >
                        <div class="tit">
                          <button
                            type="button"
                            :class="{
                              active:
                                memberBoard.paperId == item.paperId,
                            }"
                            @click="setmemberBoard(item)"
                          >
                            {{ item.paperTitle }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-menu>
              </div>
              <div v-if="error_1_1" class="error">
                {{$i18nUtil.trans("UB025")}}
              </div>
            </div>
          </div>
          <!-- 프라이빗 -->
          <div v-show="currentTab5 == 2">
            <div class="height">
              <div class="dropdown ty2 relative wide">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      :class="{
                        disabled: privFolder.categoryMid == undefined,
                      }"
                      >{{
                        privFolder.categoryMid == undefined
                          ? $i18nUtil.trans("entity.category.depth2.search.select","과정 선택")
                          : privFolder.categoryName
                      }}</v-btn
                    >
                  </template>
                  <div class="dropdown-list">
                    <div class="scroll">
                      <div
                        class="dropdown-list-item"
                        style="padding-top: 30px"
                        v-if="privFolderList.length == 0"
                      >
                        <div class="no-data">{{$i18nUtil.trans("search.014","등록된 과정이 없습니다.")}}</div>
                      </div>
                      <div
                        class="dropdown-list-item"
                        v-for="(folder, index) in privFolderList"
                        :key="'privFolderList_' + index"
                      >
                        <div class="tit">
                          <button
                            type="button"
                            :class="{
                              active:
                                privFolder.categoryMid ==
                                folder.category.categoryMid,
                            }"
                            @click="
                              [
                                getPrivBoardList(folder.category),
                                setPrivFolder(folder.category),
                              ]
                            "
                          >
                            {{ folder.category.categoryName }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-menu>
              </div>
              <div v-if="error_2_1_1" class="error">
                {{$i18nUtil.trans("UB012")}}
              </div>
            </div>
            <div class="height">
              <div class="dropdown ty2 relative wide" :class="{disabled: privFolder.categoryMid == undefined}">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      :class="{
                        disabled: privBoard.paperId == undefined,
                      }"
                      >{{
                        privBoard.paperId == undefined
                          ? $i18nUtil.trans("message.TodoLinkedModal.004","업무 보드 선택")
                          : privBoard.paperTitle
                      }}</v-btn
                    >
                  </template>
                  <div class="dropdown-list">
                    <div class="scroll">
                      <div
                        class="dropdown-list-item"
                        style="padding-top: 30px"
                        v-if="privBoardList.length == 0"
                      >
                        <div class="no-data">{{ $i18nUtil.trans("search.035","등록된 보드가 없습니다.") }}</div>
                      </div>
                      <div
                        v-else
                        class="dropdown-list-item"
                        v-for="(item, index) in privBoardList"
                        :key="'privBoardList' + index"
                      >
                        <div class="tit">
                          <button
                            type="button"
                            :class="{
                              active: privBoard.paperId == item.paperId,
                            }"
                            @click="setPrivBoard(item)"
                          >
                            {{ item.paperTitle }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-menu>
              </div>
              <div v-if="error_2_1_2" class="error">
                {{$i18nUtil.trans("UB025")}}
              </div>
            </div>
          </div>
          <!-- 회의/협의 -->
          <div v-show="currentTab5 == 3">
            <div class="height">
              <div class="dropdown ty2 relative wide">
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" class="disabled">
                          {{
                            cfrcCategory.categoryMid == undefined
                              ? $i18nUtil.trans("message.TodoLinkedModal.005","카테고리 선택")
                              : cfrcSearch
                          }}
                        </v-btn>
                    </template>
                    <div class="dropdown-list">
                        <div class="scroll">
                            <div class="dropdown-list-item"
                              v-if="cfrcCategoryList.length == 0"
                            >
                              <div class="no-data">{{ $i18nUtil.trans("message.TodoLinkedModal.002","등록된 카테고리가 없습니다.") }}</div>
                            </div>
                            <div
                              v-else 
                              class="dropdown-list-item"
                              v-for="(cfrcCategoryItem, cfrcCategoryIndex) in cfrcCategoryList"
                              :value="cfrcCategoryItem"
                              :key="'cfrcCategoryIndex_' + cfrcCategoryIndex"
                              @click="setCfrcCategory(cfrcCategoryItem)"
                            >
                              <div class="tit">
                                <button
                                  type="button"
                                  :class="{
                                    active:
                                      cfrcCategory.categoryMid == cfrcCategoryItem.categoryMid,
                                  }"
                                >
                                  {{ cfrcCategoryItem.categoryName }}
                                </button>
                              </div>
                            </div>
                        </div>
                    </div>
                </v-menu>
              </div>
              <div class="error" v-if="error_3_1">
                {{$i18nUtil.trans("UB005")}}
              </div>
            </div>
            <!-- <form action="" onsubmit="return false;" novalidate>
              <div class="search_ty1">
                <input
                  type="text"
                  required
                  placeholder="회의/협의 카테고리를 입력하세요."
                  @input="cfrcTyping"
                  :value="cfrcSearch"
                  @keyup.enter="checkCfrcName"
                />
                <button type="reset" class="btn_search" @click="cfrcTyping">검색</button>
                <div
                  class="list scroll"
                  style="height: 100px"
                  v-if="isCfrcCategoryListShow"
                >
                  <ul>
                    <li
                      class="no-data"
                      v-if="cfrcCategoryListFilter.length == 0"
                      style="padding-top: 20px"
                    >
                      등록된 카테고리가 없습니다.
                    </li>
                    <li
                      v-for="(
                        cfrcCategory, cfrcCategoryIndex
                      ) in cfrcCategoryListFilter"
                      :key="'cfrcCategoryIndex_' + cfrcCategoryIndex"
                      @click="setCfrcCategory(cfrcCategory)"
                    >
                      <button type="button">
                        {{ cfrcCategory.categoryName }}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="error" v-if="error_3_1">
                {{$i18nUtil.trans("UB005")}}
              </div>
            </form> -->
            <div class="height">
              <div
                class="dropdown ty2 relative wide"
                :class="{ disabled: cfrcCategory.categoryMid == undefined }"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on">{{
                      cfrsBoard.paperId == undefined
                        ? $i18nUtil.trans("message.TodoLinkedModal.004","업무 보드 선택")
                        : cfrsBoard.paperTitle
                    }}</v-btn>
                  </template>
                  <div class="dropdown-list">
                    <div class="scroll">
                      <div
                        class="dropdown-list-item"
                        style="padding-top: 30px"
                        v-if="cfrsBoardList.length == 0"
                      >
                        <div class="no-data">{{ $i18nUtil.trans("search.035","등록된 보드가 없습니다.") }}</div>
                      </div>
                      <div
                        v-else
                        class="dropdown-list-item"
                        v-for="(item, cfrsBoardIndex) in cfrsBoardList"
                        :key="'cfrsBoardIndex_' + cfrsBoardIndex"
                      >
                        <div class="tit">
                          <button
                            type="button"
                            @click="setCfrsBoard(item)"
                            :class="{
                              active: item.paperId == cfrsBoard.paperId,
                            }"
                          >
                            {{ item.paperTitle }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-menu>
              </div>
              <div class="error" v-if="error_3_2">
                {{$i18nUtil.trans("UB025")}}
              </div>
            </div>
          </div>
        </div>
        <div class="info-txt smaller" v-if="modalInfo.paperId != null">{{ $i18nUtil.trans("message.TodoLinkedModal2.002","* 보드 연결 변경시 이전 연결한 보드 내 할 일은 삭제되고 새로 연결한 보드에 할 일이 생성됩니다.") }}</div>
        <footer class="modal-footer" style="margin-top:25px;" v-show="currentTab5 == 0">
          <button type="button" class="btn_ty1" @click="submitCoOp">
            {{ $i18nUtil.trans("button.add","추가") }}
          </button>
        </footer>
        <footer class="modal-footer" style="margin-top:25px;" v-show="currentTab5 == 1">
          <button type="button" class="btn_ty1" @click="submitMemberBoard">
            {{ $i18nUtil.trans("button.add","추가") }}
          </button>
        </footer>
        <footer class="modal-footer" style="margin-top:25px;" v-show="currentTab5 == 2 && currentTab1 == 0">
          <button type="button" class="btn_ty1" @click="submitPrivBoard">
            {{ $i18nUtil.trans("button.add","추가") }}
          </button>
        </footer>
        <footer class="modal-footer" style="margin-top:25px;" v-show="currentTab5 == 2 && currentTab1 == 1">
          <button type="button" class="btn_ty1" @click="submitMemberPrivBoard">
            {{ $i18nUtil.trans("button.add","추가") }}
          </button>
        </footer>
        <footer class="modal-footer" style="margin-top:25px;" v-show="currentTab5 == 3">
          <button type="button" class="btn_ty1" @click="submitCfrs">
            {{ $i18nUtil.trans("button.add","추가") }}
          </button>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import axios from "axios";
import EventBus from "@/js/eventbus/eventBus";

export default {
  components: {
    Datepicker,
  },
  props: {
    //modalInfo.userInfo
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tenantId: localStorage.getItem("tenantId"),
      date: "2020.12.31",
      show: false,
      error: false,
      currentTab5: 0,
      currentTab1: 0,
      tabsTy5: localStorage.getItem("cfrcUse") === "true" ? 
          [this.$i18nUtil.trans("entity.project","과제"), this.$i18nUtil.trans("title.TodoLinkedModal.tab5.001","공유받은 비공개 보드"), this.$i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗"), this.$i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의")] 
          : [this.$i18nUtil.trans("entity.project","과제"), this.$i18nUtil.trans("title.TodoLinkedModal.tab5.001","공유받은 비공개 보드"), this.$i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗")],
      tabsTy1: [this.$i18nUtil.trans("title.TodoLinkedModal.tab1.001","나의 프라이빗"), this.$i18nUtil.trans("title.TodoLinkedModal.tab1.002","공유받은 프라이빗")],
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      error_0_1: false,
      error_0_2: false,
      error_0_3: false,
      error_1_1: false,
      error_2_1_1: false,
      error_2_1_2: false,
      error_2_2_1: false,
      error_3_1: false,
      error_3_2: false,

      //프라이빗
      privGroupInfo: {},
      privFolder: {},
      privFolderList: [],
      privBoard: {},
      privBoardList: [],
      //협업멤버 프라이빗
      memberPrivBoard: {},
      memberPrivBoardList: [],
      //공유받은 비공개 보드
      memberBoard: {},
      memberBoardList: [],

      linkedGroupInfo: {},
      groupList: [],
      groupFolder: {},
      groupFolderList: [],
      groupBoard: {},
      groupBoardList: [],
      searchProjectName: "",
      isProjectShow: false,
      paperId: null,
      projectId: null,
      projectList: [],
      projectListFilter: [],
      selectedProjectInfo: {},
      addLinkProjectId: "",
      addLinkProjectGroupId: "",
      addLinkProjectCategoryMid: "",
      addLinkProjectCategoryName: "",
      /* 폴더 */
      projectFolderList: [],
      selectedProjectFolder: {},

      //회의/협의
      cfrcCategory: {},
      cfrcCategoryList: [],
      cfrcCategoryListFilter: [],
      cfrsBoard: {},
      cfrsBoardList: [],
      isCfrcCategoryListShow: false,
      cfrcSearch: "",
      clickStatus: false,
    };
  },
  created() {
    this.getCfrcCategoryList();
  },
  mounted() {
    this.initProjectList();
  },
  methods: {
    ...mapActions("modals", ["showModal", "showToast"]),
    ...mapActions("modals", ["showModal"]),
    ...mapActions("restAction", [
      "COWORK_REST_ACTION",
      "COWORK_REST_SIMPLE_ACTION",
    ]),
    // 나의 프라이빗 리스트 S
    initPrivGroupId() {
      let obj = this;
      let reqData = {};
      reqData.params = {};
      reqData.req = obj.req;
      reqData.url = "/api/cogroup/cogroup/getMyGroupInfo";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          this.privGroupInfo = res.result;
          this.initPrivFolderList();
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    initPrivFolderList() {
      let obj = this;
      let param = {
        url: "/api/copaper/category/getGroupCategoryList",
        method: "post",
        req: {
          groupId: this.privGroupInfo.groupId,
        },
      };
      obj
        .COWORK_REST_ACTION(param)
        .then(function (res) {
          if (res.errorCode == null) {
            // obj.parentCategoryMid = res.result[0].parentCategoryMid;
            // obj.parentCategory = res.result[0].info;
            obj.privFolderList = res.result[0].list;

            // if (obj.privFolderList != null && obj.privFolderList.length > 0) {
            //   obj.getBoardList(obj.privFolderList[0].category);
            // }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
      // this.getMyCategoryList(param) // 해당 공간의 카테고리 및 폴더 리스트
    },
    getPrivBoardList(folder) {
      let obj = this;
      obj.boardList = [];

      let param = {
        url: "/api/copaper/paper/getCategoryPaperList",
        method: "post",
        req: {
          categoryMid: folder.categoryMid,
          section: "PROJECT", //'EXECUTION',
          paperStatus: null,
          projectId: folder.projectId,
          groupId: folder.groupId,
        },
      };
      obj
        .COWORK_REST_ACTION(param)
        .then(function (res) {
          if (res.errorCode == null) {
            obj.privBoardList = res.result.paperList.content;
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    // 나의 프라이빗 리스트 E

    // 협업 멤버 프라이빗 S
    initMemberPrivBoardList() {
      let obj = this;
      let reqData = {};
      reqData.params = {};
      reqData.req = obj.req;
      reqData.url = "/api/copaper/todo/getMemberPrivBoardList";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          this.memberPrivBoardList = res.result;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    // 협업 멤버 프라이빗 E

    // S
    /* 리스트 조회 */
    initProjectList() {
      let obj = this;
      let projectUrl = "/api/cogroup/project/getMyProjectList";
      let param = {};
      axios
        .post(projectUrl, param)
        .then((res) => {
          if (res.errorCode != null && res.errorCode != undefined) {
            alert(res.errorCode);
            return;
          }
          obj.projectList = res.data.result.data;
          obj.selectedProjectInfo = {};
          // 리스트 필터
          obj.setProjectFilter();
          // 보드 링크 리스트 조회
          obj.getBoardLinkProjectList();
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    getBoardLinkProjectList() {
      let obj = this;
      let projectUrl = "/api/copaper/paperlink/getBoardLinkProjectList";
      let param = { paperId: obj.paperId };
      axios
        .post(projectUrl, param)
        .then((res) => {
          if (res.errorCode != null && res.errorCode != undefined) {
            alert(res.errorCode);
            return;
          }
          obj.boardLinkProjectList = res.data.result;
          obj.$emit(
            "closeBoardLinkProjectModal",
            obj.boardLinkProjectList == null
              ? 0
              : obj.boardLinkProjectList.length
          );
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    /* 리스트 필터 */
    clearAndFilterProject(searchProjectName, _event) {
      let obj = this;
      if (searchProjectName != null && searchProjectName != "") {
        searchProjectName = "";
      }
      obj.filterProject(searchProjectName, _event);
      obj.isProjectShow = false;
      obj.selectedProjectInfo = {};
      obj.changeProject({});
    },
    filterProject(_event) {
      let obj = this;
      obj.error_0_1 = false;
      obj.searchProjectName = _event.target.value;
      if (_event.target.value == "" || _event.target.value == null) {
        obj.isProjectShow = false;
        obj.groupFolder = {};
        obj.groupFolderList = [];
        obj.groupBoard = {};
        obj.groupBoardList = [];
        obj.selectedProjectInfo = {};
        obj.addLinkProjectId = "";
        obj.addLinkProjectGroupId = "";
        obj.addLinkProjectCategoryMid = "";
        obj.addLinkProjectCategoryName = "";

        obj.changeProject({});
        return;
      }
      obj.groupFolder = {};
      obj.groupFolderList = [];
      obj.groupBoard = {};
      obj.groupBoardList = [];
      obj.selectedProjectInfo = {};
      obj.addLinkProjectId = "";
      obj.addLinkProjectGroupId = "";
      obj.addLinkProjectCategoryMid = "";
      obj.addLinkProjectCategoryName = "";
      obj.isProjectShow = true;
      obj.setProjectFilter();
    },
    setProjectFilter() {
      let obj = this;
      const blank_pattern = /^\s+|\s+$/g;
      if (obj.searchProjectName != null && obj.searchProjectName.length > 0) {
        const result = obj.projectList.filter(function (projectObj) {
          return (
            obj.searchProjectName.replace(blank_pattern, "") != "" &&
            projectObj.projectName.indexOf(obj.searchProjectName) != -1
          );
        });
        obj.projectListFilter = result;
      } else {
        obj.projectListFilter = obj.projectList;
      }
    },
    /* 변경 */
    changeProject(projectInfo) {
      let obj = this;
      obj.isProjectShow = false;
      if(obj.selectedProjectInfo == projectInfo) {
        return;
      }
      obj.selectedProjectInfo = projectInfo;
      if (
        projectInfo != null &&
        projectInfo.projectId != null &&
        projectInfo.projectId != undefined
      ) {
        obj.searchProjectName = projectInfo.projectName;
        let projectFolderUrl = "/api/copaper/category/getCategoryItemList";
        let param = {
          categoryMid: null,
          groupId: projectInfo.groupId,
          type: "PROJECT",
        };
        axios
          .post(projectFolderUrl, param)
          .then((res) => {
            if (res.errorCode != null && res.errorCode != undefined) {
              alert(res.errorCode);
              return;
            }
            obj.error_0_1 = false;
            obj.error_0_2 = false;
            obj.error_0_3 = false;
            obj.addLinkProjectId = "";
            obj.addLinkProjectCategoryMid = "";
            obj.addLinkProjectCategoryName = "";
            obj.groupBoard = {};
            obj.projectFolderList = res.data.result;
          })
          .catch((err) => {
            console.log("axios err => ", err);
          });
      } else {
        obj.addLinkProjectId = "";
        obj.addLinkProjectGroupId = "";
        obj.addLinkProjectCategoryMid = "";
        obj.addLinkProjectCategoryName = "";
        obj.projectFolderList = [];
      }
    },
    /* 단계 변경 */
    changeProjectFolder(projectFolderInfo, dtId) {
      if (projectFolderInfo == "") {
        this.addLinkProjectId = "";
        this.addLinkProjectGroupId = "";
        this.addLinkProjectCategoryMid = "";
        this.addLinkProjectCategoryName = "";
      } else {
        this.addLinkProjectId = projectFolderInfo.projectId;
        this.addLinkProjectGroupId = projectFolderInfo.groupId;
        this.addLinkProjectCategoryMid = projectFolderInfo.categoryMid;
        this.addLinkProjectCategoryName = projectFolderInfo.categoryName;
        this.groupBoard = {};
        this.groupBoardList = [];
        this.error_0_1 = false;
        this.error_0_2 = false;
        this.error_0_3 = false;
        this.getProjectBoardList();
      }
    },
    moreClose(targetId) {
      if (document.getElementById(targetId).classList.contains("active")) {
        document.getElementById(targetId).classList.toggle("active");
      }
    },
    getProjectBoardList() {
      let obj = this;
      let reqData = {};
      reqData.params = {
        categoryMid: this.addLinkProjectCategoryMid,
        section: "PROJECT", //'IDEATION',
        paperStatus: "",
        projectId: this.addLinkProjectId,
        groupId: this.addLinkProjectGroupId,
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/paper/getCategoryPaperList";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          this.groupBoardList = res.result.paperList.content;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    // E

    // 회의&협의 S
    getCfrcCategoryList() {
      let obj = this;
      let reqData = {
        url: "/api/copaper/cooperation/getCfrcCategoryListInCategoryMember",
        method: "post",
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          let list = res.result.categoryList;
          obj.cfrcCategoryList = list;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    getCfrcPaperList(param) {
      let obj = this;
      let reqData = {
        url: "/api/copaper/paper/getCfrcPaperList",
        method: "post",
        params: { categoryMid: param.categoryMid },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          obj.cfrsBoardList = res.result;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    // 회의&협의 E
    // 공유받은 비공개 보드 조회
    initMemberBoardList() {
      let obj = this;
      let reqData = {};
      reqData.params = {};
      reqData.req = obj.req;
      reqData.url = "/api/copaper/todo/getMemberBoardList";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          this.memberBoardList = res.result;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    setPrivFolder(param) {
      this.privFolder = param;
      this.privBoard = {};
      this.error_2_1_1 = false;
      // document.getElementById("privFolderListDt").classList.toggle("active");
    },
    setPrivBoard(param) {
      this.privBoard = param;
      this.error_2_1_2 = false;
      // document.getElementById("privBoardListDt").classList.toggle("active");
    },
    setmemberPrivBoard(param) {
      this.memberPrivBoard = param;
      this.error_2_2_1 = false;
      // document
      //   .getElementById("memberPrivBoardListDt")
      //   .classList.toggle("active");
    },
    setGroupBoard(param) {
      this.error_0_2 = false;
      this.groupBoard = {
        paperTitle: param.paperTitle,
        paperId: param.paperId,
      };
      // document.getElementById("groupBoardListDt").classList.toggle("active");
    },
    setCfrcCategory(param) {
      this.cfrcCategory = param;
      this.cfrcSearch = param.categoryName;
      this.isCfrcCategoryListShow = false;
      this.error_3_1 = false;
      this.error_3_2 = false;
      this.cfrsBoard = "";
      this.getCfrcPaperList(param);
    },
    setCfrsBoard(param) {
      this.cfrsBoard = param;
      this.error_3_2 = false;
      // document.getElementById("cfrsBoardListDt").classList.toggle("active");
    },
    setmemberBoard(param) {
      this.memberBoard = param;
      this.error_1_1 = false;
    },

    // 탭 이동시 주요 파라미터 제거
    paramNull() {
      this.searchProjectName = "";
      this.groupFolderList = [];
      this.privBoardList = [];
      this.groupFolderList = [];
      this.groupBoardList = [];
      this.cfrsBoardList = [];
      this.cfrcCategory = {};
      this.cfrcSearch = "";
      this.cfrsBoard = "";
      this.privFolder = {};
      this.privBoard = {};
      this.groupBoard = {};
      this.cfrsBoard = {};
      this.memberPrivBoard = {};
      this.memberBoard = {};
      this.addLinkProjectId = "";
      this.addLinkProjectGroupId = "";
      this.addLinkProjectCategoryMid = "";
      this.addLinkProjectCategoryName = "";
      this.error_0_1 = false;
      this.error_0_2 = false;
      this.error_0_3 = false;
      this.error_1_1 = false;
      this.error_2_1_1 = false;
      this.error_2_1_2 = false;
      this.error_2_2_1 = false;
      this.error_3_1 = false;
      this.error_3_2 = false;
    },

    currentTab5Click(index) {
      if (index == 1) {
        this.initMemberBoardList();        
      } else if(index == 2) {
        this.initPrivGroupId();
      }
      this.currentTab5 = index;

      this.paramNull();
    },
    currentTab1Click(index) {
      if (index == 1) {
        this.initMemberPrivBoardList();
      }
      this.currentTab1 = index;

      this.paramNull();
    },
    cfrcTyping(e) {
      const self = this;
      self.cfrcCategoryListFilter = [];
      this.cfrcSearch = e.target.value;
      if (e.target.value == "" || e.target.value == null) {
        this.isCfrcCategoryListShow = true;
        this.cfrsBoardList = [];
        this.cfrcCategory = {};
        this.cfrcSearch = "";
        this.cfrsBoard = "";
        return;
      }
      const blank_pattern = /^\s+|\s+$/g;
      this.cfrcCategoryList.forEach((item) => {
        if (
          this.cfrcSearch.replace(blank_pattern, "") != "" &&
          item.categoryName.indexOf(this.cfrcSearch) != -1
        ) {
          self.cfrcCategoryListFilter.push(item);
        }
      });
      this.isCfrcCategoryListShow = true;
      // this.getCfrcCategoryList();
    },
    cfrcView(param) {
      let chk = false;
      if (this.cfrcSearch == null || param.indexOf(this.cfrcSearch) != -1) {
        console.log("asdasdasdadAS");
        chk = true;
        this.isCfrc = true;
      }
      return chk;
    },

    submitPrivBoard() {
      if(this.clickStatus) return;
      this.clickStatus = true;

      if (this.privBoard.paperId != undefined) {
        let linkParam = {
          kbnName: this.privBoard.kbn,
          kbn: "PAPER",
          categoryName: this.privBoard.categoryName,
          categoryMid: this.privBoard.categoryMid,
          groupId: this.privBoard.groupId,
          paperId: this.privBoard.paperId,
          paperTitle: this.privBoard.paperTitle,
          targetId: this.privBoard.paperId,
        };
        this.addTodoLink(linkParam);
      } else {
       if (this.privFolder.categoryMid == undefined) {
          this.error_2_1_1 = true;
        } else {
          if (this.privFolder.paperId == undefined) {
            this.error_2_1_2 = true;
          }
        }
        this.clickStatus = false;
      }
    },
    submitMemberPrivBoard() {
      if(this.clickStatus) return;
      this.clickStatus = true;

      if (this.memberPrivBoard.paperId != undefined) {
        let linkParam = {
          kbnName: "PRIVATE",
          kbn: "PAPER",
          categoryName: this.memberPrivBoard.categoryInfo.categoryName,
          categoryMid: this.memberPrivBoard.categoryMid,
          groupId: this.memberPrivBoard.groupId,
          paperId: this.memberPrivBoard.paperId,
          paperTitle: this.memberPrivBoard.paperTitle,
          targetId: this.memberPrivBoard.paperId,
        };
        this.addTodoLink(linkParam);
      } else {
        this.error_2_2_1 = true;
        this.clickStatus = false;
      }
    },
    checkProjectName() {
      if (this.searchProjectName == "") {
        this.error_0_1 = true;
      }
    },
    checkCfrcName() {
      if (this.cfrcSearch == "") {
        this.error_3_1 = true;
      }
    },
    submitCoOp() {
      if(this.clickStatus) return;
      this.clickStatus = true;
      
      if (this.selectedProjectInfo.projectId != undefined) {
        let param = this.selectedProjectInfo;
        let linkParam = {};
        if (
          this.addLinkProjectCategoryName == null ||
          this.addLinkProjectCategoryName == ""
        ) {
          /**
          linkParam = {
            kbnName: "",
            kbn: "PRO",
            categoryName: param.projectName,
            projectId: param.projectId,
            groupId: param.groupId,
            paperTitle: param.projectName,
            targetId: param.projectId,
          };
          this.addTodoLink(linkParam);
           */
          this.error_0_3 = true;
          this.clickStatus = false;
        } else if (this.groupBoard.paperId == undefined) {
          this.error_0_2 = true;
          this.clickStatus = false;
        } else {
          linkParam = {
            kbnName: this.$i18nUtil.trans("entity.project","과제"),
            kbn: "PAPER",
            categoryName: this.addLinkProjectCategoryName,
            categoryId: this.addLinkProjectCategoryMid,
            projectId: param.projectId,
            groupId: param.groupId,
            paperTitle: this.groupBoard.paperTitle,
            paperId: this.groupBoard.paperId,
            targetId: this.groupBoard.paperId,
          };
          this.addTodoLink(linkParam);
        }
      } else {
        this.error_0_1 = true;
        this.clickStatus = false;
      }
    },
    submitCfrs() {
      if(this.clickStatus) return;
      this.clickStatus = true;

      let param = this.cfrsBoard;
      let paramCate = this.cfrcCategory;

      if (this.cfrcCategory.categoryMid == undefined) {
        this.error_3_1 = true;
        this.clickStatus = false;
      } else {
        if (param.paperId != undefined) {
          let linkParam = {
            kbnName: this.$i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의"),
            kbn: "PAPER",
            categoryName: param.categoryName,
            categoryMid: param.categoryMid,
            groupId: param.groupId,
            paperId: param.paperId,
            paperTitle: param.paperTitle,
            targetId: param.paperId,
          };
          this.addTodoLink(linkParam);
        } else {
          /**
          let linkParam = {
            kbnName: "회의/협의",
            kbn: "CFRC",
            categoryName: paramCate.categoryName,
            categoryMid: paramCate.categoryMid,
            groupId: paramCate.groupId,
            paperId: '',
            paperTitle: paramCate.categoryName,
            targetId: paramCate.categoryMid,
          };
          this.addTodoLink(linkParam);
           */
          this.error_3_2 = true;
          this.clickStatus = false;
        }
      }
    },
    submitMemberBoard() {
      if(this.clickStatus) return;
      this.clickStatus = true;

      if (this.memberBoard.paperId != undefined) {
        let linkParam = {
          kbnName: this.$i18nUtil.trans("message.TodoLinkedModal.006","공유받은보드"),
          kbn: "PAPER",
          categoryName: this.memberBoard.categoryInfo.categoryName,
          categoryMid: this.memberBoard.categoryMid,
          groupId: this.memberBoard.groupId,
          paperId: this.memberBoard.paperId,
          paperTitle: this.memberBoard.paperTitle,
          targetId: this.memberBoard.paperId,
        };
        this.addTodoLink(linkParam);
      } else {
        this.error_1_1 = true;
        this.clickStatus = false;
      }
    },
    addTodoLink(linkParam) {
      //  console.log(this.modalInfo);
      if(linkParam.targetId == this.modalInfo.paperId){
        // console.log("targetId : ",linkParam.targetId,",orgPaperId : ",this.modalInfo.paperId);
        // 같은 보드 선택
        // this.toastInfo.message = this.$i18nUtil.trans("이미 연결된 보드입니다.");
        // this.showToast(this.toastInfo);
        this.$emit("close");
        return;
      }
      let obj = this;
      let reqData = {
        url: "/api/copaper/todo/updateLink",
        method: "post",
        params: {
          //todoId: this.modalInfo.todoId,
          targetId: linkParam.targetId,
          paperId : this.modalInfo.paperId,
          todoMainId : this.modalInfo.todoMainId,
          kbn: linkParam.kbn,
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          EventBus.$emit("board_TodoInfo_getLinkList", linkParam);
          if (
            obj.modalInfo.parents != undefined &&
            obj.modalInfo.parents == "TodoLinkedListModal2"
          ) {
            EventBus.$emit("refreshTodoLinkedListModal2", linkParam);
          }
          EventBus.$emit("refreshTodoNewPage");
          EventBus.$emit("refreshTodoBoard");
          obj.toastInfo.message = obj.$i18nUtil.trans("TB100");
          obj.showToast(obj.toastInfo);
          obj.$emit("close");
        })
        .catch(function (err) {
          this.clickStatus = false;
          console.log(err);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/cowork/general/board/todo/popup/TodoLinkedModal2.vue